import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Brand } from '../../types/catalog';
import { financeCirculars } from '../../data/circulars';
import { isExpired, formatDate } from '../../utils/format';
import { managementFeeText } from '../../utils/circular';
import { CircularTable } from './CircularTable';
interface BrandCircularsProps {
  brands: Brand[];
  /** Marca elegida en el simulador; si tiene circular, se muestra esa. */
  brandId: string;
  onBrandChange: (brandId: string) => void;
}

/** Circulares oficiales por marca, visibles en el simulador antes de elegir una versión. */
export function BrandCirculars({
  brands,
  brandId,
  onBrandChange
}: BrandCircularsProps) {
  const active = financeCirculars.filter(c => !isExpired(c.validUntil));
  if (!active.length) return null;
  const current = active.find(c => c.brandId === brandId) ?? active[0];
  const nameOf = (id: string) => brands.find(b => b.id === id)?.name ?? id;
  const selectedHasNone = brandId && !active.some(c => c.brandId === brandId);
  return <section className="card p-5 sm:p-6" aria-labelledby="circulars-title" data-id="element-966" data-mp="2pp3hpszarg9x">
      <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-967" data-mp="2un58l02ysjvy">
        <div data-id="element-968" data-mp="2zen2j46klk7f">
          <h2 id="circulars-title" className="font-display text-xl font-black tracking-tight sm:text-2xl" data-id="element-969" data-mp="2zg7vwqh5ex3p">Circulares oficiales de financiación</h2>
          <p className="mt-1 text-sm text-mist" data-id="element-970" data-mp="34g3zwppuioj9">Líneas vigentes de cada marca. Elegí modelo y versión arriba para calcular tu cuota exacta.</p>
        </div>
        <FileTextIcon className="hidden h-6 w-6 text-neon sm:block" aria-hidden data-id="element-971" data-mp="2bqdia6p094ie" />
      </div>

      {selectedHasNone && <p className="mt-4 rounded-lg bg-warn/10 px-3 py-2 text-xs text-warn" data-id="element-972" data-mp="2gndpwm1i6fbm">
          {nameOf(brandId)} todavía no tiene una circular cargada: se simula con sus condiciones generales.
        </p>}

      <div role="tablist" aria-label="Marca" className="mt-5 flex flex-wrap gap-2" data-id="element-973" data-mp="3s5ybl3yfi71x">
        {active.map(c => {
        const on = c.brandId === current.brandId;
        return <button key={c.brandId} role="tab" type="button" aria-selected={on} onClick={() => onBrandChange(c.brandId)} className={`rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors duration-150 ${on ? 'border-neon bg-neon/15 text-white shadow-[0_0_12px_rgba(31,168,255,0.35)]' : 'border-line text-mist hover:text-white'}`} data-id="element-974" data-mp="1wyuks7dih53d">
              {nameOf(c.brandId)}
            </button>;
      })}
      </div>

      <div role="tabpanel" className="mt-5" data-id="element-975" data-mp="1n2hrvbpsiv9o">
        <p className="mb-3 text-xs text-mist" data-id="element-976" data-mp="1n3b0ki8b7uug">
          {current.lender} · {current.reference} · Vigente hasta el {formatDate(current.validUntil)} · Cuotas con IVA, sin seguro automotor · {managementFeeText(current)}
        </p>
        <CircularTable circular={current} lines={current.lines} data-id="element-977" data-mp="uk40nuyym7jk" />
      </div>
    </section>;
}